import TextField from "@mui/material/TextField";
import React from "react";

export default function PhoneCell(props) {
  const { rowData, handleChange } = props;

  return (
    <>
      {rowData.showInput ? (
        <div className="flex-1 h-full">
          <TextField
            InputProps={{
              style: {
                borderRadius: "10px",
              },
            }}
            value={rowData.detail}
            onChange={(newValue) => {
              const value = newValue.target.value;
              handleChange(rowData.dataKey, value);
            }}
            size="small"
            className="w-full"
          />
        </div>
      ) : (
        <div
          className="h-full border border-[#B3B3B3] bg-[#B3B3B3] bg-opacity-[26%] px-0 py-[10px] text-sm"
          style={{
            flex: 1,
            textAlign: rowData.textAlign || "start",
          }}
        >
          <p className="leading-[18px] pl-4 tracking-[1.75px] truncate">
            {rowData.detail || "-"}
          </p>
        </div>
      )}
    </>
  );
}